import { useQuery } from "@redux-requests/react";
import { Grid, Button, Menu, ListItemText, makeStyles, MenuItem } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { Link as RouterLink, useParams } from "react-router-dom";
import { BaseLayout, Header, Loader } from "../components";
import AccessList from "../components/AccessList";
import { getPhysicalRoom, getPhysicalRoomUsers, createBatchQrScanLog } from "../ducks/actions";
import * as types from "../ducks/types";
import { useActionRequest } from "../hooks";
import { ReactComponent as BadgeScanSvg } from "../assets/icons/badge scan.svg";

const useStyles = makeStyles(theme => ({
  button: {
    width: "150px",
    [theme.breakpoints.up("md")]: {
      margin: "16px;"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: "16px;"
    }
  }
}));

const PhysicalRoomPage = () => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();

  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(0);
  const [perPage] = useState(10);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setAllAsExited = useActionRequest({
    action: createBatchQrScanLog
  });

  const onSetAllAsExited = async () => {
    await setAllAsExited({ roomId: id, action: "exit" });
    dispatch(getPhysicalRoomUsers({ roomId: id, filter, page: page + 1, perPage }));
  };

  useEffect(() => {
    dispatch(getPhysicalRoom({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(getPhysicalRoomUsers({ roomId: id, filter, page: page + 1, perPage }));
  }, [dispatch, id, filter, page, perPage]);

  const {
    data: { physical_room: physicalRoom },
    loading: physicalRoomLoading
  } = useQuery({
    type: types.GET_PHYSICAL_ROOM,
    defaultData: { physical_room: {} }
  });

  const {
    data: {
      users,
      meta: { total: totalUsers }
    },
    loading: usersLoading
  } = useQuery({
    type: types.GET_PHYSICAL_ROOM_USERS,
    defaultData: { users: [], meta: { total: 0 } }
  });

  return (
    <BaseLayout>
      <Loader loading={physicalRoomLoading || usersLoading}>
        <Header icon={BadgeScanSvg} title={physicalRoom.name} />
        <Grid container spacing={2}>
          <Grid item xs={12} mt={2}>
            <Button
              variant="contained"
              className={classes.button}
              controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              {intl.formatMessage({
                id: "Pages.PhysicalRoom.Scan",
                defaultMessage: "SCAN"
              })}
            </Button>
            <Button variant="contained" className={classes.button} onClick={() => setOpen(true)}>
              {intl.formatMessage({
                id: "Pages.PhysicalRoom.List",
                defaultMessage: "LIST"
              })}
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "center"
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center"
              }}
            >
              <MenuItem
                button
                component={RouterLink}
                to={`/physical_rooms/${id}/qr-scan?action=enter`}
              >
                <ListItemText primary="Enter" />
              </MenuItem>
              <MenuItem
                button
                component={RouterLink}
                to={`/physical_rooms/${id}/qr-scan?action=exit`}
              >
                <ListItemText primary="Exit" />
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
        {open && (
          <AccessList
            users={users}
            filter={filter}
            setFilter={setFilter}
            totalUsers={totalUsers}
            setPage={setPage}
            page={page}
            perPage={perPage}
            setAllAsExited={onSetAllAsExited}
            roomId={id}
          />
        )}
      </Loader>
    </BaseLayout>
  );
};

export default PhysicalRoomPage;
